<template>
    <div class="add-finance-dialog">
        <el-dialog
            :close-on-click-modal="closeOnClickModal"
            :title="title"
            :visible.sync="openAddFinanceDialog"
            top="4%"
            style="min-width: 1200px;"
            :before-close="closeDialog">
            <el-form inline ref="form" :model="form" :rules="rules" label-width="110px" size="mini" style="font-size: 14px;">
                <el-form-item label="银行账户" prop="bankAccount">
                    <el-input v-model="form.bankAccount" placeholder="请输入银行账户" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="银行账户名" prop="bankAccountName">
                    <el-input v-model="form.bankAccountName" placeholder="请输入银行账户名"></el-input>
                </el-form-item>
                <el-form-item label="开户行名称" prop="bankName">
                    <advance
                        :mValue="form.bankName"
                        class="advance-item"
                        :formData="{ status: '1' }"
                        :params="params"
                        @getAdvanceValue='getAdvanceValue'>
                    </advance>
                </el-form-item>
                <el-form-item label="开户行编号" prop="bankCode">
                    <el-input v-model="form.bankCode" placeholder="请输入开户行编号" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="联行号" prop="ubankNo">
                    <el-input v-model="form.ubankNo" placeholder="请输入联行号" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="开户行地址" prop="bankAddress">
                    <el-input v-model="form.bankAddress" placeholder="请输入开户行地址"  :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="币种" prop="accountCurrencyName">
                    <!-- <m-select :optionNum="'SU_CURRENCY'" :value="form.accountCurrency" :filterable="true" @input="getAccountCurrency" class="select-item"></m-select> -->
                    <advance
                        :mValue="form.accountCurrencyName"
                        class="advance-item"
                        :params="currencyData"
                        @getAdvanceValue='getCurrencyValue'>
                    </advance>
                </el-form-item>
                <el-form-item label="账户类型" prop="accountType">
                    <m-select ref="accountType" :optionNum="'SYS_ACCOUNTS_TYPE'" :value="form.accountType" :filterable="true" @input="setValue($event, 'accountType')"  class="select-item"></m-select>
                </el-form-item>
                <el-form-item label="省份" prop="provinceCode">
                    <m-select class="select-item" :flag="provinceOptions" :optionArr="provinceOptions" :value="form.provinceCode" :filterable="true"
                        @getSelectLabel="getLabel($event, 'provinceNameCn')" @input="setValue($event, 'provinceCode')"></m-select>
                </el-form-item>
                <el-form-item label="城市" prop="cityCode">
                    <m-select class="select-item" :flag="cityOptions" :optionArr="cityOptions" :value="form.cityCode" :filterable="true"
                        @getSelectLabel="getLabel($event, 'cityNameCn')" @input="setValue($event, 'cityCode')"></m-select>
                </el-form-item>
                <el-form-item label="SWIFT CODE" prop="swiftCode">
                    <el-input v-model.trim="form.swiftCode" placeholder="请输入银行统一编号"></el-input>
                </el-form-item>
            </el-form>
            <div class="certificate-item">
                <span class='title-item'>委托付款函</span>
                <span class="upload-item">
                    <upload
                        :uploadDisplayType="uploadDisplayType"
                        :text="text"
                         @uploadSuccess="callback">
                    </upload>
                </span>
                <span class="upload-item">
                    <el-button class="certificate-temp-btn" type="text" @click="handleTempDownload">下载模板</el-button>
                </span>
                <el-table border :data="certificateData">
                    <el-table-column
                        prop="localFileName"
                        label="附件名称"
                        width="400">
                    </el-table-column>
                    <el-table-column
                        prop=""
                        label="操作"
                        width="">
                        <template slot-scope="scope">
                            <el-button type="text" class="preview-btn" @click="preview(scope.row)">预览</el-button>
                            <el-button @click="handleRemove(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button :loading="loading" type="primary" @click="confirmDialog">确 定</el-button>
            </span>
        </el-dialog>
        <preview
            v-if='attachmentShow'
            :attachmentShow.sync='attachmentShow'
            :rowData='rowData'>
        </preview>
    </div>
</template>
<script>
import advance from '../../../../../components/bulletFrame/otpAdvance';
import upload from '../../../../../components/upload/Index';
import mSelect from '../../../../../components/Select.vue';
import preview from '../../../../../components/AttachmentDialog';
import { getProvinces, getCitys } from '../../../../../utils/getArea';
import { saveWorkbenchBankAccount, changeBySupplier, searchByAddress, downloadRegisterGuide } from '../../../../../api/finance.js';
import { COMPANY } from '../../../../../constant/constant.js';

const BILL = 'BILL'; // 账户类型-票据户
const MIDEA_PAY = 'MIDEA_PAY'; // 账户类型-美的付
const CHINA_CODE = '100000';
export default {
    name: 'add-finance-dialog',
    components: { advance, upload, preview, mSelect },
    props: {
        title: {
            type: String,
            default() {
                return '';
            }
        },
        openAddFinanceDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        row: {
            type: Object,
            default() {
                return false;
            }
        },
        disabled: {
            type: Boolean,
            default() {
                return false;
            }
        },
        supplierTab: {
            type: Object,
            default() {
                return {
                    supplierCode: '',
                    supplierName: '',
                    propertyNature: 0
                };
            }
        }
    },
    data() {
        return {
            closeOnClickModal: false,
            form: {
                supplierCode: ''
            },
            accountCurrency: '',
            rules: {
                bankAccount: [
                    { required: true, message: '请输入银行账户', trigger: ['blur', 'change'] },
                    { pattern: /^[0-9a-zA-Z\-]+$/, message: '请输入字母或数字或"-"', trigger: ['blur', 'change'] }
                ],
                bankAccountName: [
                    { required: true, message: '请输入银行账户名', trigger: ['blur', 'change'] }
                ],
                bankCode: [
                    { required: true, message: '请输入开户行编号', trigger: ['blur', 'change'] },
                    { pattern: /^[0-9a-zA-Z]+$/, message: '请输入数字或字母', trigger: ['blur', 'change'] }
                ],
                ubankNo: [
                    { required: true, message: '请输入联行号', trigger: ['blur', 'change'] },
                    { pattern: /^[0-9a-zA-Z]+$/, message: '请输入数字或字母', trigger: ['blur', 'change'] }
                ],
                // bankAddress: [
                //     { required: true, message: '请输入开户行地址', trigger: ['blur', 'change'] }
                // ],
                accountCurrencyName: [
                    { required: true, message: '请输入币种', trigger: ['blur', 'change'] }
                ],
                accountType: [
                    { required: true, message: '请选择账户类型', trigger: ['blur', 'change'] }
                ],
                swiftCode: [
                    { pattern: /^[0-9a-zA-Z]+$/, message: '请输入数字或字母', trigger: ['blur', 'change'] },
                    { max: 14, message: '最多可输入14位', trigger: ['blur', 'change'] },
                ],
                bankName: [
                    { required: true, message: '请选择开户行', trigger: ['blur', 'change'] }
                ]
            },
            params: {
                name: '',
                value: 'bankName',
                advanceLabel: '选择开户行名称',
                requestMethod: 'post',
                advanceConfig: [
                    { prop: 'bankname', value: '银行名称' },
                    { prop: 'banknumber', value: '银行号' },
                    { prop: 'ubankno', value: '联行号' },
                    { prop: 'bankaddress', value: '开户行地址' }
                ],
                tableConfig: [
                    { prop: 'banknumber', value: '银行号' },
                    { prop: 'bankname', value: '银行名称' },
                    { prop: 'ubankno', value: '联行号' },
                    { prop: 'bankaddress', value: '开户行地址' }
                ],
                advanceUrl: '/efContactNumbers',
                prefix: '/api-mdm',
                cbParams: ['banknumber#bankCode', 'bankname#bankName', 'ubankno#ubankNo', 'bankaddress#bankAddress'],
                advanceCascade: 'status',
                width: '1000px',
                tableBorder: true,
            },
            currencyData: {
                value: 'accountCurrency',
                advanceConfig: [
                    { prop: 'nameCn', value: '币种名称' },
                    { prop: 'currency', value: '币种代码' }
                ],
                advanceUrl: '/efCurrency/search',
                cbParams: ['currency#companyCode', 'nameCn#accountCurrencyName'],
                name: '币种',
                tableConfig: [
                    { prop: 'currency', value: '币种代码' },
                    { prop: 'nameCn', value: '币种名称' }
                ],
                default: '人民币元'
            },
            uploadDisplayType: 'iconAndText',
            text: '上传',
            certificateData: [],
            attachmentShow: false,
            loading: false,
            provinceOptions: [],
            cityOptions: []
        };
    },
    methods: {
        closeDialog() {
            this.$emit('update:openAddFinanceDialog', false);
        },
        confirmDialog() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if (this.form.accountType === BILL) {
                        this.$confirm('请确认当前账户类型是否有收取票据的功能', '提示', {
                            confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                        }).then(() => {
                            this.submitData();
                        }).catch(() => { });
                    } else {
                        this.submitData();
                    }
                }
            });
        },
        submitData() {
            this.loading = true;
            if (this.title === '新增') {
                this.form.supplierCode = this.supplierTab.supplierCode;
                saveWorkbenchBankAccount(this.form).then(res => {
                    this.$emit('updateTable');
                    if (res && res.code === '0') {
                        this.$message.success('新增成功');
                        this.closeDialog();
                    }
                }).finally(() => { this.loading = false; });
            } else {
                const { bankName, bankCode, ubankNo, bankAddress, bankAccountName, accountCurrencyName, accountCurrency, accountType, bankAccount, id, swiftCode } = this.form;
                const { provinceCode, provinceNameCn, cityCode, cityNameCn } = this.form;
                let params = { bankName, bankCode, ubankNo, bankAddress, bankAccountName, accountCurrencyName, accountCurrency, accountType, bankAccount, id, swiftCode };
                params = { ...params, provinceCode, provinceNameCn, cityCode, cityNameCn, supplierCode: this.supplierTab.supplierCode };
                if (this.certificateData.length !== 0) {
                    params = { ...params, fileId: this.certificateData[0].id, fileName: this.certificateData[0].localFileName, fileUrl: this.certificateData[0].downUrl };
                }
                changeBySupplier(params).then(res => {
                    this.$emit('updateTable');
                    if (res && res.code === '0') {
                        this.$message.success('变更成功');
                        this.closeDialog();
                    }
                }).finally(() => { this.loading = false; });
            }
        },
        getAdvanceValue(data) {
            this.$set(this.form, 'bankName', data.bankName);
            this.$set(this.form, 'bankCode', data.bankCode);
            this.$set(this.form, 'ubankNo', data.ubankNo);
            this.$set(this.form, 'bankAddress', data.bankAddress);

            searchByAddress({ address: data.bankName }).then(res => {
                if (res && +res.code === 0) {
                    this.$set(this.form, 'provinceCode', res.data.provinceCode);
                    this.$set(this.form, 'provinceNameCn', res.data.provinceNameCn);
                    this.$set(this.form, 'cityCode', res.data.cityCode);
                    this.$set(this.form, 'cityNameCn', res.data.cityNameCn);
                    this.setRegionOptions();
                }
            });
        },
        getCurrencyValue(data) {
            this.accountCurrency = data.companyCode;
            this.$set(this.form, 'accountCurrencyName', data.accountCurrencyName);
            this.form.accountCurrency = this.accountCurrency;
        },
        callback(data) {
            if (this.certificateData.length > 0) {
                this.$message.warning('只能上传一个附件');
            } else {
                if (data.data.code === '0') {
                    if (data.data.data.localFileName && data.data.data.localFileName.length > 100) {
                        return this.$message.warning('文件名称不能超过100个字符');
                    }
                    this.form.fileId = data.data.data.id;
                    this.form.fileName = data.data.data.localFileName;
                    this.form.fileUrl = data.data.data.downUrl;
                    this.$message.success('上传成功');
                    this.certificateData.push(data.data.data);
                }
            }
        },
        handleRemove(row) {
            this.certificateData = [];
            this.form.fileName = '';
            this.form.fileUrl = '';
        },
        preview(data) {
            data.fileName = data.localFileName;
            this.rowData = data;
            this.attachmentShow = true;
        },
        getAccountCurrency(data) {
            this.form.accountCurrency = data;
        },
        setValue(data, key) {
            // 主体性质 法人，账户类型 美的付
            if (key === 'accountType' && this.supplierTab.propertyNature === COMPANY && data === MIDEA_PAY) {
                this.$message.warning('法人供应商请选择非美的付账户类型');
                this.form.accountType = null;
                this.$refs['accountType'].cValue = null;
                return false;
            }
            this.$set(this.form, key, data);
            if (key === 'provinceCode') {
                this.$set(this.form, 'cityCode', null);
                this.$set(this.form, 'cityNameCn', null);
                this.setRegionOptions();
            }
        },
        getLabel(data, key) {
            this.$set(this.form, key, data);
        },
        setRegionOptions() {
            if (this.provinceOptions.length === 0) {
                getProvinces(CHINA_CODE).then(res => {
                    this.provinceOptions = res;
                });
            }
            if (this.form.provinceCode) {
                getCitys(this.form.provinceCode).then(res => {
                    this.cityOptions = res;
                });
            }
        },
        handleTempDownload() {
            downloadRegisterGuide({
                fileName: 'ConsignmentCollectionTemplate.docx'
            }).then(res => {
                if (res) {
                    const blob = new Blob([res], {
                        type: 'application/x-excel;charset=UTF-8'
                    });
                    const objectUrl = URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = '委托付款函模板.docx';
                    a.click();
                }
            });
        }
    },
    mounted() {
        this.form = { ...this.row };
        if (this.title === '变更' && this.form.fileName) {
            this.certificateData = [{
                id: this.form.fileId,
                localFileName: this.form.fileName,
                downUrl: this.form.fileUrl
            }];
        }
        this.setRegionOptions();
    }
};
</script>
<style lang="less">
.add-finance-dialog {
    .advance-item {
        width: 160px;
    }

    .certificate-item {
        margin-left: 4%;
        width: 90%;

        .title-item {
            float: left;
            margin: 10px 0;
        }

        .upload-item {
            float: right;
            margin: 10px 0;
            color: #00BCBF;

            .certificate-temp-btn {
                padding-top: 4px;
                padding-bottom: 0;
                margin-right: 20px;
            }
        }
    }

    .preview-btn {
        color: #00BCBF;
    }

    .select-item {
        width: 160px;
    }
}
</style>
